// Components
import Text from '@components/helpers/text/Text'

const SelectionDescription = ({ text }: { text: string }) => {
  return (
    <Text
      tagName="p"
      variant="body-2"
      color="grey"
      spacing={{ sm: 24, lg: 64 }}
      fontWeight={400}
      mobile
    >
      {text}
    </Text>
  )
}

export default SelectionDescription
